/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import classNames from 'classnames';

import Picker from '@emoji-mart/react';

import styles from '../styles/uikitReactionsEmojiPicker.module.scss';

const EmojiPicker = ({
  className = '',
  closePicker = () => {},
  isActive,
  onClickOutside = () => {},
  onEmojiSelect,
  testId = 'uikit-emoji-picker',
  ...rest
}) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') closePicker();
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div
      className={classNames(styles.element, className)}
      data-testid={testId}
    >
      {isActive && (
        <Picker
          theme="light"
          testId="emoji-mart-picker"
          onEmojiSelect={onEmojiSelect}
          onClickOutside={onClickOutside}
          emoji="point_up"
          title={i18n.t('chat.emoji-picker-open-aria-label')}
          autoFocus
          {...rest}
        />
      )}
    </div>
  );
};

EmojiPicker.propTypes = {
  className: PropTypes.string,
  closePicker: PropTypes.func,
  isActive: PropTypes.bool.isRequired,
  onClickOutside: PropTypes.func,
  onEmojiSelect: PropTypes.func.isRequired,
  testId: PropTypes.string,
};

export default React.memo(EmojiPicker);
